import React from 'react';
import PropTypes from 'prop-types';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

import queryClient from './client';
import AsyncStorage from './Storage';

const persister = createAsyncStoragePersister({
  storage: AsyncStorage,
  serialize: (client) => client,
  deserialize: (client) => client,
});

const onRestoreSuccess = () =>
  queryClient.resumePausedMutations().then(() => {
    queryClient.invalidateQueries();
  });

const ReactQueryProvider = ({ children }) => (
  <PersistQueryClientProvider
    client={queryClient}
    persistOptions={{ persister }}
    onSuccess={onRestoreSuccess}
  >
    {children}
    <ReactQueryDevtools />
  </PersistQueryClientProvider>
);

ReactQueryProvider.propTypes = {
  children: PropTypes.node,
};

export default ReactQueryProvider;
